import React from "react";
import { useTranslation } from "react-i18next";


const ResultAfter = props => {
  const { t } = useTranslation()
  const { dotsSecondStep } = props;
  console.log(dotsSecondStep)
  return (
    <div className="col-lg-6 col-xs-12" >
      <div style={{ border: "1px solid #ccc", backgroundColor: "black" }}>
        <p className="text-center text-light">{t('secondStep')}</p>
        <div className="col-xs-12 mt-1 text-center">
          {/*  <div className="row d-block text-center">
        <div className={`dot-empty m-1`}>{dotsSecondStep[0] ? <div className="letter">{dotsSecondStep[0].slice(0, 1).toUpperCase()}</div> : null}</div>
      </div> */}
          <span className={`dot-results m-1 ${dotsSecondStep[0]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[1]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[2]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[3]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[4]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[5]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[6]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[7]}`}></span>
        </div>
        <div className="col-xs-12 text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[8]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[9]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[10]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[11]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[12]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[13]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[14]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[15]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[16]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[17]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[18]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[19]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[20]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[21]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[22]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[23]}`}></span>
        </div>

        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[24]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[25]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[26]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[27]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[28]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[29]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[30]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[31]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[32]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[33]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[34]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[35]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[36]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[37]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[38]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[39]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[40]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[41]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[42]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[43]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[44]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[45]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[46]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[47]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[48]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[49]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[50]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[51]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[52]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[53]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[54]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[55]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[56]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[57]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[58]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[59]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[60]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[61]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[62]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[63]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[64]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[65]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[66]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[67]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[68]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[69]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[70]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[71]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[72]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[73]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[74]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[75]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[76]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[77]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[78]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[79]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[80]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[81]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[82]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[83]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[84]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[85]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[86]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[87]}`}></span>
        </div>
        <div className="row d-block text-center">
          <span className={`dot-results m-1 ${dotsSecondStep[88]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[89]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[90]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[91]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[92]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[93]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[94]}`}></span>
          <span className={`dot-results m-1 ${dotsSecondStep[95]}`}></span>
        </div>
      </div>
    </div>
  );
};

export default ResultAfter;
